import React from 'react';
import { ApplicationPaths } from './auth/constants';
function Profile() {
    var handleLogout = function () {
        location.href = "#" + ApplicationPaths.Logout;
    };
    return (React.createElement("div", { className: "container" },
        "Profile",
        React.createElement("p", null,
            "  ",
            React.createElement("button", { onClick: handleLogout }, "Logout"))));
}
export default Profile;
